import React from 'react'
import FormFactory from '../../helpers/FormFactory'
import I18n from 'i18n'
import Routes from '../../common/Routes'
import { Link } from 'react-router-dom'
import { addSearchToPath } from '../../common/Utils'
import { WithFlashMessages } from '../../flashmessages/FlashMessageProvider'

interface ExternalSignupResponse {
  data: {
    user: {
      id: number
      email: string
    }
    meta?: {
      participant_pseudo_id?: string
    }
  }
  status: number
  statusText: string
  headers: Record<string, string>
  config: any
  request: any
}

interface HistoryLocation {
  pathname: string
  search?: string
  state?: { participantId: string | null }
}

export interface ExternalOrganizationSignUpProps {
  formName: string
  setHeight: (targetHeight: string | number, duration?: number) => void
  getFields: (formName: string) => Record<string, any>
  handleChange: (e: any, formName: string, field: string) => void
  flashMessages: any
  history: { push: (location: string | HistoryLocation) => void }
}

class ExternalOrganizationSignup extends FormFactory {
  // Provided by helpers / base class but not typed here
  addSearchToPath: (path: string) => string
  form_fields: Record<string, any>
  constructor (props: ExternalOrganizationSignUpProps) {
    super(props)
    this.addSearchToPath = addSearchToPath.bind(this)
    this.form_fields = {
      secret_key: {
        component: 'field',
        properties: {
          type: 'password'
        }
      },
      email: {
        component: 'field',
        properties: {
          type: 'email'
        }
      },
      password: {
        component: 'field',
        properties: {
          type: 'password'
        }
      },
      password_confirm: {
        component: 'field',
        properties: {
          type: 'password'
        }
      },
      first_name: {
        component: 'field',
        propKey: 'first_name',
        properties: {
          type: 'text'
        }
      },
      last_name: {
        component: 'field',
        propKey: 'last_name',
        properties: {
          type: 'text'
        }
      },
      code: {
        component: 'hidden-get',
        propKey: 'c'
      },
      locale: {
        component: 'hidden-props',
        propKey: 'locale',
        properties: {
          locale: I18n.locale
        }
      },
      birth_date: {
        component: 'hidden-props',
        propKey: 'birth_date',
        properties: {
          birth_date: new Date('1990-01-01')
        }
      }
    }
  }

  componentDidMount (): void {
    this.props.setHeight(775)
  }

  handleSuccess (response: ExternalSignupResponse): void {
    const participantId = response?.data?.meta?.participant_pseudo_id ?? null
    if (participantId === null || participantId === undefined || participantId === '') {
      this.props.flashMessages.push(
        I18n.t('devise.registrations.no_participant_id'),
        this.props.flashMessages.duration.LONG,
        this.props.flashMessages.levels.ERROR
      )
    } else {
      this.props.history.push({
        pathname: '/external-signup-successful',
        search: `?pid=${encodeURIComponent(participantId)}`,
        state: { participantId }
      })
    }
  }

  renderUnder16Panel (): React.ReactNode {
    return null
  }

  renderTermsAndConditionsCheckBox (): React.ReactNode {
    const termsFormField = {
      component: 'checkbox',
      properties: {
        type: 'checkbox'
      }
    }

    return this.renderSingleField('terms', termsFormField)
  }

  render (): JSX.Element {
    return (
      <form method='post'>
        {this.renderFields()}
        {this.renderUnder16Panel()}
        {this.renderTermsAndConditionsCheckBox()}
        {this.renderSubmit(`${this.props.formName as string}.submit`, {
          id: 'signup-button',
          className:
            'button-primary background-primary text-background-color waves-effect waves-light'
        })}
        <div className='row'>
          <div className='col s12'>
            <ul>
              <li>
                <Link
                  id='terms-and-conditions'
                  to={Routes.static.termsAndConditionsLatest}
                >
                  {I18n.t('login.link.terms_and_conditions')}
                </Link>
              </li>
              <li>
                <Link
                  id='privacy-statement'
                  to={Routes.static.privacyStatement}
                >
                  {I18n.t('login.link.privacy_statement')}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </form>
    )
  }
}

export default WithFlashMessages(
  ExternalOrganizationSignup
) as unknown as React.ComponentType<ExternalOrganizationSignUpProps>
